import { createSlice } from '@reduxjs/toolkit'
import { userKey } from 'data/constants'

/**
 * Verifica si existe el token de un usuario.
 * @returns {boolean} Retorna true si existe el usuario en caso contrario false.
 */
function isLogged() {
	const _user = localStorage.getItem(userKey)
	if (_user) {
		try {
			const data = JSON.parse(_user)
			if (data.access_token) {
				return true
			}
		} catch (error) {
			localStorage.removeItem(userKey)
		}
	}
	return false
}

const initialState = {
	isLogged: !!isLogged(),
	user: null,
	roles: [],
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthData: (state, { payload }) => ({ ...state, ...payload }),
		clearAuthData: () => ({ ...initialState, isLogged: false }),
	},
})
const { setAuthData, clearAuthData } = authSlice.actions
export default authSlice.reducer

export function setLoginData(access_token) {
	return (dispatch) => {
		localStorage.setItem(userKey, JSON.stringify({ access_token }))
		dispatch(setAuthData({ access_token, isLogged: true }))
	}
}
export function clearLoginData() {
	return (dispatch) => {
		localStorage.removeItem(userKey)
		dispatch(clearAuthData())
	}
}
export function setUserData(user, roles) {
	return (dispatch) => {
		dispatch(setAuthData({ user, roles }))
	}
}

